















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import DateUtils from '@/common/js/DateUtils'
import Enums from '@/lib/enums'
import appconst from '@/lib/appconst';
import { routers } from '@/router/router'
import CreateUrgentOrder from './urgentorder-add.vue'
import EditUrgentOrder from './urgentorder-edit.vue'


class AmountListRequest extends PageRequest {
    orderNumber: string;
    BeginTime?: Date;
    EndTime?: Date;
    whetherHandle?: boolean;
}


@Component({
    name: "fronturgentorderlist",
    components: { CreateUrgentOrder, EditUrgentOrder }
})
export default class Orders extends AbpBase {
    whetherStockStatus = Enums.getEnum(Enums.WhetherStatus, true);
    creationTime: Date[]=[];
    createModalShow: boolean = false;
    editModalShow: boolean = false;
    pagerequest: AmountListRequest = new AmountListRequest();
    get list() {
        return this.$store.state.fronturgentorder.list;
    };
    get loading() {
        return this.$store.state.fronturgentorder.loading;
    }
    pageChange(page: number) {
        this.$store.commit('fronturgentorder/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('fronturgentorder/setPageSize', pagesize);
        this.getpage();
    }
    async searchPage() {
        this.$store.state.fronturgentorder.currentPage = 1;
        this.getpage();
    }
    async add() {
        this.createModalShow = true;
    }
    async Edit(data: any) {
        this.$store.state.fronturgentorder.id = data.id;
        this.$store.state.fronturgentorder.logisitcsNumber = data.logisitcsNumber;
        this.$store.state.fronturgentorder.reason = data.reason;
        this.editModalShow = true;
    }
    async getpage() {
        if (this.creationTime.length > 0) {
            this.pagerequest.BeginTime = this.creationTime[0];
        } else {
            this.pagerequest.BeginTime = null;
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.EndTime = this.creationTime[1];
        } else {
            this.pagerequest.EndTime = null;
        }

        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

        await this.$store.dispatch({
            type: 'fronturgentorder/getAll',
            data: this.pagerequest
        });
    }
    get pageSize() {
        return this.$store.state.fronturgentorder.pageSize;
    }
    get totalCount() {
        return this.$store.state.fronturgentorder.totalCount;
    }
    get currentPage() {
        return this.$store.state.fronturgentorder.currentPage;
    }
    columns = [
       
        {
            title: '订单编号',
            key: 'orderNumber',
            align:"center",
            width: 250,
        },
        {
            title: '包裹状态',
            width: 90,
            key: 'packageStatus',
            render: (h: any, params: any) => {
                return h('span', params.row.packageStatus?Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name:"");
            }
        },
        {
            title: '物流单号',
            key: 'logisitcsNumber',
            align: "center",
            width: 250,
        },
        {
            title: '创建时间',
            key: 'creationTime',
            align:"center",
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
            }
        }, 
        {
            title: '原因',
            key: 'reason',
            align: "center",
            width: 250,
        },
        {
            title: '是否处理',
            key: 'whetherHandle',
            align: "center",
            width: 150,
            render: (h: any, params: any) => {
                return h('span', params.row.whetherHandle ? "是" : "否");
            }
        }, 
        {
            title: '处理备注',
            key: 'handleRemark',
            align: "center",
            width: 350,
        },
        {
            title: '操作',
            width: 120,
            fixed: 'right',
            key: 'id',
            render: (h: any, params: any) => {
                var _this = this;
                var menu = [];
                var data = params.row;

                return h('div', [

                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            height: '30px',
                            width: '85px',
                            // display: (data.packageStatus == 4 && data.orderStatus == 0) ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                var _this = this;
                               _this.Edit(data);

                            }
                        }

                    }, "编辑"),


                ]);

            }
        }
    ]
    async created() {
        this.getpage();
    }
}
